import React from "react";
import TradesTable from "./TradesTable";

interface TradesPageProps {
  selectedWalletId: string | null;
}

export function TradesPage({ selectedWalletId }: TradesPageProps) {
  return <TradesTable selectedWalletId={selectedWalletId} />;
}

export default TradesPage;
